import "./src/styles/global.css"
import "./src/styles/layout.css"
// Fonts laddas asynkront för att undvika kritiska förfrågningar
import { wrapPageElement as wrap } from "./src/i18n/wrapPageElement"

export const wrapPageElement = wrap

function applyTheme(theme) {
  const root = document.documentElement
  if (theme === "dark") root.classList.add("dark"); else root.classList.remove("dark")
  root.style.colorScheme = theme === "dark" ? "dark" : "light"
}

export const onClientEntry = () => {
  try {
    // Ladda fonter asynkront för att undvika kritiska förfrågningar
    const loadFonts = () => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = '/fonts.css'
      link.media = 'print'
      link.onload = function() { this.media = 'all' }
      document.head.appendChild(link)
    }
    
    // Ladda fonter efter initial render
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadFonts)
    } else {
      loadFonts()
    }
    
    // Tema-hantering utan localStorage (endast för denna session)
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
    applyTheme(prefersDark ? "dark" : "light")
    
    // Enkel språkdetection baserat på webbläsare - ingen lagring!
    const currentPath = window.location.pathname
    const isRootPath = currentPath === '/' || currentPath === '/index.html'
    
    // Endast redirecta från root-sidan
    if (isRootPath) {
      // Detektera webbläsarens språk
      const browserLang = navigator.language || navigator.userLanguage
      const isSwedish = browserLang.startsWith('sv')
      
      console.log('🌐 Detected browser language:', browserLang, '→', isSwedish ? 'Swedish' : 'English')
      
      // Redirecta svenska användare till /sv/
      if (isSwedish) {
        console.log('🔄 Redirecting Swedish user to /sv/')
        window.location.replace('/sv/')
        return
      }
      
      // Engelska användare stannar på root (/)
      console.log('🔄 English user stays on /')
    }
  } catch {}
}

export const onRouteUpdate = ({ location }) => {
  // Detektera språk baserat på URL och sätt lang-attribut
  const lang = location.pathname === "/sv" || location.pathname.startsWith("/sv/") ? "sv" : "en"
  document.documentElement.setAttribute("lang", lang)
  
  console.log('🔄 Language set to:', lang, 'for path:', location.pathname)
}